import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBI: CultureInfo = {
  name: 'en-BI',
  displayName: 'English (Burundi)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BI',
  parent: CultureInfoEn
};
